import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

if (window.BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: window.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
    releaseStage: window.APP_ENV,
    appVersion: window.APP_VERSION,
    enabledReleaseStages: window.BUGSNAG_ENABLED_STAGES || [
      "production",
      "staging",
    ], // Read from window, fallback
    appType: "vue-client",
    consoleBreadcrumbsEnabled: true,
    logger: null,
    metadata: {
      device: {
        hostname: window.location.hostname,
        userAgent: navigator.userAgent,
      },
    },
    onSession: function (session) {
      if (window.USER != null) {
        session.setUser(window.USER);
      }
    },
    onError(event) {
      // Filter out noisy browser errors
      if (
        event.originalError &&
        event.originalError.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        return false;
      }
      // Attach user context to error events
      if (window.USER != null) {
        event.setUser(window.USER.id, window.USER.email, window.USER.name);
      }
    },
  });
}
